import { Injectable, signal } from '@angular/core';

/**
 * Global open/close state for the slide-in Agent Chat panel.
 *
 * Kept separate from the conversation orchestrator so the floating launcher and
 * the panel can toggle visibility without pulling in the websocket/HTTP layer.
 * Provided in root → the same panel instance is reachable from every page.
 */
@Injectable({ providedIn: 'root' })
export class AgentChatPanelService {
    private readonly _isOpen = signal(false);
    readonly isOpen = this._isOpen.asReadonly();

    open(): void {
        this._isOpen.set(true);
    }

    close(): void {
        this._isOpen.set(false);
    }

    toggle(): void {
        this._isOpen.update(v => !v);
    }
}
